export default [
  { text: "activity.resource_type.ACTIVITY", value: "ACTIVITY" },
  { text: "activity.resource_type.DOCUMENT", value: "DOCUMENT" },
  { text: "activity.resource_type.IMAGE", value: "IMAGE" },
  { text: "activity.resource_type.LINK", value: "LINK" },
  { text: "activity.resource_type.VIDEO", value: "VIDEO" },
  { text: "activity.resource_type.AUDIO", value: "AUDIO" },
];
